





















































































































































import Vue from 'vue';
import { Subscribers, recognition } from 'mycorems-app-accounts';
import { PaymentsTable, PaymentMethods } from 'mycorems-app-billing';
import isGranted from '@/auth/isGranted';
import { Client } from '@/types';
import clientRepository from '../account/client/client-repository';
import ClientSummary from '../account/client/ClientSummary.vue';
import FetchEmailCampaignsBtn from './FetchEmailCampaignsBtn.vue';
import EmailCampaignsTable from './EmailCampaignsTable.vue';
import EmailReportTab from './report/EmailReportTab.vue';
import ReportRecipients from '../account/client/ReportRecipients.vue';
import AccountSettings from '../account-settings/AccountSettings.vue';
import ListCustomFieldsTable from '../account/client/ListCustomFieldsTable.vue';

interface Data {
  viewableEmailCampaignId: string|null,
  client: Client|null,
  task: Promise<Client>|null,
  tabLabel: object,
}

export default Vue.extend({
  meta() {
    return {
      // @ts-ignore
      title: this.pageTitle,
    };
  },
  props: {
    clientId: {
      type: String,
      required: true,
    },
    tab: {
      type: String,
      default: 'campaigns',
    },
    reportId: String,
  },
  data(): Data {
    return {
      viewableEmailCampaignId: null,
      client: null,
      task: null,
      tabLabel: {
        campaigns: 'Campaigns',
        summary: 'Summary',
        report: 'Reports',
        subscribers: 'Subscribers',
        'report-recipients': 'Report Recipients',
        automation: 'Automation',
        'custom-fields': 'Custom Fields',
        'api-key': 'API Key',
        'payment-methods': 'Payment Methods',
        billing: 'Billing',
      },
    };
  },
  watch: {
    clientId: {
      handler(): void {
        this.clearViewableReport();
        this.loadClient();
      },
      immediate: true,
    },
  },
  computed: {
    pageTitle(): string {
      const tab = this.tabLabel[this.tab];
      if (!this.client) return tab;
      return `${tab} - ${this.client.name}`;
    },
    isAgency(): boolean {
      return recognition.isAgency();
    },
    isClient(): boolean {
      return recognition.isClient();
    },
  },
  methods: {
    getTabLabel(tab: string): string {
      return this.tabLabel[tab];
    },
    tabRoute(tab?: string): object {
      return {
        name: 'client_dashboard',
        params: {
          clientId: this.clientId,
          tab,
        },
      };
    },
    reportTabRoute(): object {
      return {
        name: 'client_dashboard',
        params: {
          clientId: this.clientId,
          tab: 'report',
          reportId: this.viewableEmailCampaignId,
        },
      };
    },
    clearViewableReport(): void {
      this.viewableEmailCampaignId = null;
    },
    viewReport(emailCampaignId: string): void {
      this.viewableEmailCampaignId = emailCampaignId;
      this.$router.push(this.reportTabRoute());
    },
    loadClient(): void {
      this.task = clientRepository.find(this.clientId);
      this.task.then((client: Client) => {
        this.client = client;
      });
    },
    isGranted,
  },
  created(): void {
    this.loadClient();
  },
  components: {
    ClientSummary,
    FetchEmailCampaignsBtn,
    EmailCampaignsTable,
    EmailReportTab,
    Subscribers,
    ReportRecipients,
    PaymentsTable,
    PaymentMethods,
    AccountSettings,
    ListCustomFieldsTable,
  },
});
